import styled from '@emotion/styled'
import { Checkmark } from 'components'
import Heading from 'components/Heading'
import Text from 'components/Text'

const CheckoutTipButtonView = styled.button<{
  isApplied?: boolean
  disabled?: boolean
}>`
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 0;
  border-style: solid;
  border-width: ${(props) => props.theme.buttons.sizes.large.borderWidth};
  border-radius: ${(props) => props.theme.buttons.sizes.large.borderRadius};
  background-color: ${(props) => props.theme.buttons.colors.large.bgColor};
  border-color: ${(props) =>
    props.isApplied
      ? props.theme.colors.success
      : props.theme.buttons.colors.large.borderColor};

  &:disabled {
    opacity: 1;
  }

  &:hover {
    background-color: ${(props) =>
      props.isApplied || props.disabled
        ? props.theme.buttons.colors.large.bgColor
        : props.theme.buttons.colors.largeHover.bgColor};
    border-color: ${(props) =>
      props.isApplied
        ? props.theme.colors.success
        : props.disabled
        ? props.theme.buttons.colors.large.bgColor
        : props.theme.buttons.colors.largeHover.borderColor};
  }

  & > span {
    display: block;
    text-align: center;
  }
`

const CheckoutTipButtonCheckmark = styled.div`
  position: absolute;
  z-index: 2;
  top: -0.8rem;
  right: -0.8rem;
`

const CheckoutTipButtonTitle = styled(Heading)<{ isApplied?: boolean }>`
  transition: ${(props) => props.theme.links.transition};
  font-size: ${(props) => props.theme.fonts.sizes.medium};
  color: ${(props) => props.theme.buttons.colors.large.color};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.small};
  }

  button:enabled:hover & {
    color: ${(props) => props.theme.buttons.colors.largeHover.color};
  }
`

const CheckoutTipButtonSubtitle = styled(Text)<{ isApplied?: boolean }>`
  margin: 0.3rem 0 0;
  transition: ${(props) => props.theme.links.transition};
  font-size: ${(props) => props.theme.fonts.sizes.small};
  color: ${(props) => props.theme.buttons.colors.large.subtitleColor};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  }

  button:enabled:hover & {
    color: ${(props) => props.theme.buttons.colors.largeHover.subtitleColor};
  }
`

const CheckoutTipButton = ({
  title,
  subtitle,
  onPress,
  isApplied,
  disabled,
}: {
  title: string
  subtitle: string
  onPress: () => void
  isApplied?: boolean
  disabled?: boolean
}) => {
  return (
    <CheckoutTipButtonView
      onClick={onPress}
      disabled={disabled}
      isApplied={isApplied}
    >
      {isApplied ? (
        <CheckoutTipButtonCheckmark>
          <Checkmark />
        </CheckoutTipButtonCheckmark>
      ) : null}
      <CheckoutTipButtonTitle isApplied={isApplied}>
        {title}
      </CheckoutTipButtonTitle>
      {subtitle && (
        <CheckoutTipButtonSubtitle isApplied={isApplied}>
          {subtitle}
        </CheckoutTipButtonSubtitle>
      )}
    </CheckoutTipButtonView>
  )
}

export default CheckoutTipButton
